import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "magento_backend-module"
    }}>{`Magento_Backend module`}</h1>
    <p>{`The Magento_Backend module contains common infrastructure and assets for other modules to be defined and used in their
administration user interface (UI).`}</p>
    <p>{`The Magento_Backend module does not contain anything specific to other modules. Among many things it handles the logic of authenticating and authorizing users.`}</p>
    <h2 {...{
      "id": "installation-details"
    }}>{`Installation details`}</h2>
    <p>{`Before disabling or uninstalling this module, note that the following modules depends on this module:`}</p>
    <ul>
      <li parentName="ul">{`Magento_Analytics`}</li>
      <li parentName="ul">{`Magento_Authorization`}</li>
      <li parentName="ul">{`Magento_NewRelicReporting`}</li>
      <li parentName="ul">{`Magento_ProductVideo`}</li>
      <li parentName="ul">{`Magento_ReleaseNotification`}</li>
      <li parentName="ul">{`Magento_Search`}</li>
      <li parentName="ul">{`Magento_Security`}</li>
      <li parentName="ul">{`Magento_Swatches`}</li>
      <li parentName="ul">{`Magento_Ui`}</li>
      <li parentName="ul">{`Magento_User`}</li>
      <li parentName="ul">{`Magento_Webapi`}</li>
    </ul>
    <p>{`For information about module installation in Magento 2, see `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/commerce-operations/installation-guide/tutorials/manage-modules.html"
      }}>{`Enable or disable modules`}</a>{`.`}</p>
    <h2 {...{
      "id": "structure"
    }}>{`Structure`}</h2>
    <p>{`Beyond the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/architecture/modules/overview/"
      }}>{`usual module file structure`}</a>{` the module contains a directory `}<inlineCode parentName="p">{`Service/V1`}</inlineCode>{`.`}</p>
    <p><inlineCode parentName="p">{`Service/V1`}</inlineCode>{` - contains logic to provide a list of modules installed in Magento.`}</p>
    <p>{`For information about typical file structure of a module in Magento 2, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/build/component-file-structure/#module-file-structure"
      }}>{`Module file structure`}</a>{`.`}</p>
    <h2 {...{
      "id": "extensibility"
    }}>{`Extensibility`}</h2>
    <p>{`Extension developers can interact with the Magento_Backend module. For more information about the Magento extension mechanism, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/plugins/"
      }}>{`Magento plug-ins`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/dependency-injection/"
      }}>{`The Magento dependency injection mechanism`}</a>{` enables you to override the functionality of the Magento_Backend module.`}</p>
    <h3 {...{
      "id": "events"
    }}>{`Events`}</h3>
    <p>{`The module dispatches the following events:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_block_html_before`}</inlineCode>{` event in the `}<inlineCode parentName="li">{`\\Magento\\Backend\\Block\\Template::_toHtml()`}</inlineCode>{` method. Parameters:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`block`}</inlineCode>{` is the backend block template (this) (`}<inlineCode parentName="li">{`\\Magento\\Backend\\Block\\Template`}</inlineCode>{` class).`}</li>
        </ul>
      </li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_store_edit_form_prepare_form`}</inlineCode>{` event in the `}<inlineCode parentName="li">{`\\Magento\\Backend\\Block\\System\\Store\\Edit\\AbstractForm::_prepareForm()`}</inlineCode>{` method. Parameters:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`block`}</inlineCode>{` is the AbstractForm block (this) (`}<inlineCode parentName="li">{`\\Magento\\Backend\\Block\\System\\Store\\Edit\\AbstractForm`}</inlineCode>{` class).`}</li>
        </ul>
      </li>
      <li parentName="ul"><inlineCode parentName="li">{`backend_block_widget_grid_prepare_grid_before`}</inlineCode>{` event in the `}<inlineCode parentName="li">{`\\Magento\\Backend\\Block\\Widget\\Grid::_prepareGrid()`}</inlineCode>{` method. Parameters:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`grid`}</inlineCode>{` is the widget grid block (this) (`}<inlineCode parentName="li">{`\\Magento\\Backend\\Block\\Widget\\Grid`}</inlineCode>{` class)`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`collection`}</inlineCode>{` is the grid collection (`}<inlineCode parentName="li">{`\\Magento\\Framework\\Data\\Collection`}</inlineCode>{` class).`}</li>
        </ul>
      </li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_cache_flush_system`}</inlineCode>{` event in the `}<inlineCode parentName="li">{`\\Magento\\Backend\\Console\\Command\\CacheCleanCommand::performAction()`}</inlineCode>{` method.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_cache_flush_all`}</inlineCode>{` event in the `}<inlineCode parentName="li">{`\\Magento\\Backend\\Console\\Command\\CacheFlushCommand::performAction()`}</inlineCode>{` method.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`clean_catalog_images_cache_after`}</inlineCode>{` event in the `}<inlineCode parentName="li">{`\\Magento\\Backend\\Controller\\Adminhtml\\Cache\\CleanImages::execute()`}</inlineCode>{` method.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`clean_media_cache_after`}</inlineCode>{` event in the `}<inlineCode parentName="li">{`\\Magento\\Backend\\Controller\\Adminhtml\\Cache\\CleanMedia::execute()`}</inlineCode>{` method.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`clean_static_files_cache_after`}</inlineCode>{` event in the `}<inlineCode parentName="li">{`\\Magento\\Backend\\Controller\\Adminhtml\\Cache\\CleanStaticFiles::execute()`}</inlineCode>{` method.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_cache_flush_all`}</inlineCode>{` event in the `}<inlineCode parentName="li">{`\\Magento\\Backend\\Controller\\Adminhtml\\Cache\\FlushAll::execute()`}</inlineCode>{` method.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_cache_flush_system`}</inlineCode>{` event in the `}<inlineCode parentName="li">{`\\Magento\\Backend\\Controller\\Adminhtml\\Cache\\FlushSystem::execute()`}</inlineCode>{` method.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`theme_save_after`}</inlineCode>{` event in the `}<inlineCode parentName="li">{`\\Magento\\Backend\\Controller\\Adminhtml\\System\\Design\\Save::execute()`}</inlineCode>{` method.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`backend_auth_user_login_success`}</inlineCode>{` event in the `}<inlineCode parentName="li">{`\\Magento\\Backend\\Model\\Auth::login()`}</inlineCode>{` method. Parameters:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`user`}</inlineCode>{` is the credential storage object (`}<inlineCode parentName="li">{`null | \\Magento\\Backend\\Model\\Auth\\Credential\\StorageInterface`}</inlineCode>{`)`}</li>
        </ul>
      </li>
      <li parentName="ul"><inlineCode parentName="li">{`backend_auth_user_login_failed`}</inlineCode>{` event in the `}<inlineCode parentName="li">{`\\Magento\\Backend\\Model\\Auth::login()`}</inlineCode>{` method. Parameters:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`user_name`}</inlineCode>{` is username extracted from the credential storage object (`}<inlineCode parentName="li">{`null | \\Magento\\Backend\\Model\\Auth\\Credential\\StorageInterface`}</inlineCode>{`)`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`exception`}</inlineCode>{` any exception generated (`}<inlineCode parentName="li">{`\\Magento\\Framework\\Exception\\LocalizedException | \\Magento\\Framework\\Exception\\Plugin\\AuthenticationException`}</inlineCode>{`)`}</li>
        </ul>
      </li>
    </ul>
    <p>{`For information about an event in Magento 2, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/events-and-observers/#events"
      }}>{`Events and observers`}</a>{`.`}</p>
    <h3 {...{
      "id": "layouts"
    }}>{`Layouts`}</h3>
    <p>{`This module introduces the following layouts and layout handles in the `}<inlineCode parentName="p">{`view/adminhtml/layout`}</inlineCode>{` directory:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`admin_login`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_auth_login`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_cache_block`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_cache_index`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_dashboard_customersmost`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_dashboard_customersnewest`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_dashboard_index`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_dashboard_productsviewed`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_denied`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_noroute`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_system_account_index`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_system_design_edit`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_system_design_grid`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_system_design_grid_block`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_system_design_index`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_system_store_deletestore`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_system_store_editstore`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_system_store_grid_block`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`adminhtml_system_store_index`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`default`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`editor`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`empty`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`formkey`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`overlay_popup`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`popup`}</inlineCode></li>
    </ul>
    <p>{`For more information about layouts in Magento 2, see the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/frontend-core/guide/layouts/"
      }}>{`Layout documentation`}</a>{`.`}</p>
    <h3 {...{
      "id": "ui-components"
    }}>{`UI components`}</h3>
    <p>{`You can extend Magento_Backend module using the following configuration files:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`view/adminhtml/ui_component/design_config_form.xml`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`view/adminhtml/ui_component/design_config_listing.xml`}</inlineCode></li>
    </ul>
    <p>{`For information about UI components in Magento 2, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/frontend-core/ui-components/"
      }}>{`Overview of UI components`}</a>{`.`}</p>
    <h2 {...{
      "id": "additional-information"
    }}>{`Additional information`}</h2>
    <p>{`For information about significant changes in patch releases, see `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/commerce-operations/release/notes/overview.html"
      }}>{`Release information`}</a>{`.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 102.0.7.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      